/*
Grilla Expandible, con un boton que permite agregar datos
Maneja los creditos (solicitud de credito aprobada)

Autor: Benjamín León
Fecha: 2024-11-28

*/
import React, { useState } from 'react'

import { formatDateToDDMMYYYY, formatWithThousandSep, makeCreditDescription } from '../utils/utils'
import Credit from '../interfaces/Credit'

import ConfirmationModal from './ConfirmationModal'
import { ButtonActionShort } from './Buttons'

interface GridExpProps {
  title: string
  array: Credit[] // contiene los creditos concedidos
  credit: Credit | null // contiene el credito seleccionado
  onCreditChange: (credit: Credit | null) => void
}

const SalenoteCredit: React.FC<GridExpProps> = ({ title, array, credit, onCreditChange }) => {
  /*
    useEffect(() => {
      onCreditChange(credit);
    }, [credit]);
*/
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null)
  const [selectedId, setSelectedId] = useState<string>() // State to track the selected button
  const [showCreditList, setShowCreditList] = useState<boolean>(false)
  const [btnAceptarDisabled, setBtnAceptarDisabled] = useState<boolean>(true)

  const handleAgregarClick = () => {
    setShowCreditList(true)
  }
  const onDeleteClick = (key: string) => {
    setSelectedItemId(key) // Store the item ID in the state
    setIsModalOpen(true)
  }
  // Este y el siguiente son para el "delete"
  const handleConfirm = () => {
    setIsModalOpen(false)
    // Perform delete action here
    onCreditChange(null)

    console.log('Item deleted:' + selectedItemId)
    setSelectedItemId(null)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setSelectedItemId(null)
  }
  // Fin delete

  // Se acepta el credito seleccionado
  const handleCreditAceptarClick = () => {
    if (!selectedId) return
    const credit = array.find((c) => c._id === selectedId)

    onCreditChange(credit!)
    setShowCreditList(false)
  }
  const handleCreditCancelarClick = () => {
    setShowCreditList(false)
  }
  // Click en alguno de los option de los créditos
  const setRadioSelected = (id: string) => {
    setSelectedId(id)
    setBtnAceptarDisabled(false)
  }

  return (
    <div>
      <div className="flex">
        <div className="text-2xl w-48">{title}</div>
        <div className="flex-1">
          <ButtonActionShort label="Agregar..." handleButtonClick={handleAgregarClick} />
        </div>
      </div>
      {credit && (
        <div className="grid grid-cols-6 border-t">
          <div className="border-b pr-4 col-span-3">{makeCreditDescription(credit)}</div>

          <div className="border-b pr-4">{formatDateToDDMMYYYY(new Date(credit.updatedAt ?? new Date()))}</div>
          <div className="border-b pr-4 text-right">${formatWithThousandSep(credit.amount)}</div>
          <button
            className="border-b pr-4 cursor-pointer hover:text-red-500 focus:outline-none focus:ring-2"
            onClick={() => onDeleteClick(credit._id)}
            aria-label="Delete"
          >
            &#x1F5D1;
          </button>

          {isModalOpen && (
            <ConfirmationModal
              message="¿Estás seguro de eliminar este crédito de la Nota de Venta?"
              onConfirm={handleConfirm}
              onCancel={handleCancel}
            />
          )}
        </div>
      )}
      {showCreditList && (
        <>
          {' '}
          {array.length > 0 ? (
            <div className="grid grid-cols-6 border-t">
              {array.map((credit) => (
                <React.Fragment key={credit._id}>
                  <div className="border-b pr-4 col-span-3">{makeCreditDescription(credit)}</div>
                  <div className="border-b pr-4">{formatDateToDDMMYYYY(new Date(credit.updatedAt ?? new Date()))}</div>
                  <div className="border-b pr-4 text-right">${formatWithThousandSep(credit.amount)}</div>
                  <div className="border-b flex items-center justify-center">
                    <input
                      type="radio"
                      name="creditOption"
                      value={credit._id}
                      checked={selectedId === credit._id}
                      onChange={() => setRadioSelected(credit._id)}
                      className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                    />
                  </div>
                </React.Fragment>
              ))}
            </div>
          ) : (
            <div> No hay créditos para este cliente y vehículo</div>
          )}
          <div className="flex justify-center mt-4 space-x-4">
            <ButtonActionShort
              label="Aceptar"
              handleButtonClick={handleCreditAceptarClick}
              disabled={btnAceptarDisabled}
            />
            <ButtonActionShort label="Cancelar" handleButtonClick={handleCreditCancelarClick} />
          </div>
        </>
      )}
    </div>
  )
}

export default SalenoteCredit
